var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultiTagIcon = function SvgMultiTagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13536_16296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.40885 5.44833L2.84969 9.03167C2.43552 9.61083 2.43552 10.39 2.84969 10.9692L5.40885 14.5525C5.72135 14.99 6.22635 15.25 6.76469 15.25H15.8339C16.7547 15.25 17.5005 14.5042 17.5005 13.5833V6.41667C17.5005 5.49583 16.7547 4.75 15.8339 4.75H6.76469C6.22635 4.75 5.72135 5.01 5.40885 5.44833Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13536_16296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export { SvgMultiTagIcon as ReactComponent };
export default __webpack_public_path__ + "multi-tag-icon.svg";